var _rect, _mask, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 399,
    height: 399,
    fill: "white",
    stroke: "#FAFAFA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_258_103",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H400V51H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H400V51H0V0Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1H-1V0H0ZM400 0H401V-1H400V0ZM0 1H400V-1H0V1ZM399 0V51H401V0H399ZM1 51V0H-1V51H1Z",
    fill: "#FAFAFA",
    mask: "url(#path-2-inside-1_258_103)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 82,
    width: 172,
    height: 19,
    rx: 5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 277,
    width: 172,
    height: 19,
    rx: 5,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 313,
    width: 240,
    height: 19,
    rx: 5,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 349,
    width: 336,
    height: 19,
    rx: 5,
    fill: "#0291D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 171,
    width: 172,
    height: 19,
    rx: 5,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 207,
    width: 172,
    height: 19,
    rx: 5,
    fill: "#0291D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 118,
    width: 172,
    height: 19,
    rx: 5,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 25.5,
    r: 12.5,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 21,
    width: 26,
    height: 9,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 21,
    width: 26,
    height: 9,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 21,
    width: 26,
    height: 9,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.a54c9967f78102736f69d9003d655ae7.svg";
export { ForwardRef as ReactComponent };